import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import IrePromo from '@/components/event/IrePromo.vue';
import IreInvite from '@/components/event/IreInvite.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionView',
  setup(__props) {

const route = useRoute();

const id = route.params.id

const getComponent = () => {

  if (route.params.id === '1') {
    return IrePromo;
  }
  if (route.params.id === 'ire-invitation') {
    return IreInvite;
  }

  return NotFoundView;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent())))
      ]),
      _: 1
    })
  ]))
}
}

})